import React, { useEffect, useState } from "react";
import { X, Save, Settings } from "lucide-react";
import "./app.css";
import Loading from "./loading";
import { secretKey } from "./data";

const API = "https://apiftpsplit.ftpeople.pl";
const hdrs = { "Content-Type": "application/json", Authorization: secretKey };

const Conf = (props) => {
  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);
  const [statuses, setStatuses] = useState([]);

  /* ── fetch (parallel) ── */
  useEffect(() => {
    (async () => {
      try {
        const [srcRes, stRes] = await Promise.all([
          fetch(`${API}/getLeadSources`, {
            method: "POST",
            headers: hdrs,
            body: "{}",
          }),
          fetch(`${API}/getStatuses`, {
            method: "POST",
            headers: hdrs,
            body: "{}",
          }),
        ]);
        setSources(await srcRes.json());
        setStatuses(await stRes.json());
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    })();
  }, []);

  /* ── toggle helpers ── */
  const toggleCSV = (current, setter, value) => {
    const arr = current ? current.split(",").filter(Boolean) : [];
    if (arr.includes(value)) {
      setter(arr.filter((v) => v !== value).join(","));
    } else {
      setter([...arr, value].join(","));
    }
  };

  const isChecked = (csv, value) => {
    if (!csv) return false;
    return csv.split(",").includes(value);
  };

  /* ── checkbox group ── */
  const CheckGroup = ({ title, items, csv, setter, allValue = "all" }) => (
    <div className="conf-group">
      <div className="conf-group-title">{title}</div>
      <div className="conf-options">
        <label className="conf-option conf-option--all">
          <span className="conf-option-name">Wszystkie</span>
          <input
            type="checkbox"
            className="db-check"
            checked={csv === allValue}
            onChange={() => setter(allValue)}
          />
        </label>
        {items.map((s) => (
          <label key={s.name} className="conf-option">
            <span className="conf-option-name" title={s.name}>
              {s.name.length > 28 ? s.name.substring(0, 28) + "…" : s.name}
            </span>
            <input
              type="checkbox"
              className="db-check"
              checked={isChecked(csv, s.name)}
              onChange={() => toggleCSV(csv, setter, s.name)}
            />
          </label>
        ))}
      </div>
    </div>
  );

  return (
    <div
      className="sn-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.close();
      }}
    >
      <div className="sn-modal" style={{ maxWidth: 520 }}>
        {/* ── Header ── */}
        <div className="sn-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Settings size={18} />
            <div>
              <h2 className="sn-title">Konfiguracja zapytania</h2>
              <span className="sn-subtitle">Wybierz statusy i źródła</span>
            </div>
          </div>
          <button className="ld-close" onClick={props.close}>
            <X size={18} />
          </button>
        </div>

        {/* ── Body ── */}
        <div className="sn-body">
          {loading ? (
            <Loading />
          ) : (
            <>
              <CheckGroup
                title="Statusy"
                items={statuses}
                csv={props.queryStatus}
                setter={props.setQueryStatus}
              />
              <CheckGroup
                title="Źródła"
                items={sources}
                csv={props.querySource}
                setter={props.setQuerySource}
              />

              <div className="conf-footer">
                <button className="lq-btn lq-btn--muted" onClick={props.close}>
                  Anuluj
                </button>
                <button
                  className="lq-btn lq-btn--success"
                  onClick={() => {
                    props.getData();
                    props.close();
                  }}
                >
                  <Save size={14} /> Zapisz
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Conf;
